import { Navigate } from "react-router-dom"
import { lazy } from "react"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const StaffProfilePage = lazy(() => import("./pages/StaffProfilePage"))
const Setup2faPage = lazy(() => import("./pages/Setup2faPage"))

export const staffUserProfileRoutes = {
  "sidebar-shell.start-align.default-background": [
    {
      path: "profile",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <StaffProfilePage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    // This path has been replaced, this makes sure old path still works
    { path: "settings", element: <Navigate to="/profile" /> },
  ],
  "fullscreen-shell.center-align.alt-background": [
    {
      path: "profile/2fa-setup",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <Setup2faPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
}
